import TenantUsers from "./TenantUsers";

export default function AdminConsole() {
  return <TenantUsers />;
}
